import Counter from './counter';
import PickupRequestTable from './pickupRequestTable';
import OnDeliveryStats from './on_delivery_stats';
import ParcelEntry from './parcel_entry';
import UserLog from '../user-log/table';
import ParcelLog from './parcel-log';

export default function Dashboard() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 grid-flow-row auto-rows-auto">
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg md:col-span-2">
        <Counter />
      </div>
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg">
        <PickupRequestTable />
      </div>
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg">
        <OnDeliveryStats />
      </div>
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg">
        <UserLog />
      </div>
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg">
        <ParcelLog />
      </div>
      <div className="p-4 border-2 border-gray-300 rounded-lg shadow-lg">
        <ParcelEntry />
      </div>

      {/* Recent Deposits */}
      {/* <div className="w-full md:w-1/3 lg:w-1/4">
        <Paper className={fixedHeightPaper}>{/* <Deposits /> </Paper>
      </div> */}
      {/* Recent Orders */}

      {/* <div className="w-full">
        <Paper className={classes.paper}> <Orders /> </Paper>
      </div> */}
    </div>
  );
}
